import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V2 } from '@studio/constants/env-variables';
import type { Users } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V2}/customers/@id/users`,
    response: [] as Users.Get.V2.User[],
    params: {} as { id: string },
    method: HTTP_METHODS.GET,
  },
};

export const id = {};
